import styled from '@emotion/styled';
import { MenuItem, Select } from '@mui/material';

export const StyledSelect = styled(Select)<{ ismobile: 'true' | 'false' }>`
  line-height: 30px;
  font-weight: 800;
  ${({ ismobile }) =>
    ismobile === 'true' &&
    `
    max-width: calc(50vw - 50px);
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
    margin: 10px 5px;
  `}
  margin-left: 20px;
  margin-top: 20px;
`;

export const StyledSelectSchoolItem = styled(MenuItem)`
  max-width: 450px;
  font-weight: 500;
`;

export const StyledMenuTitle = styled('div')`
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 20px;
`;
